import React, { useState, useEffect } from 'react';
import { Box, useMediaQuery, useTheme, Typography } from '@mui/material';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import GlobalLoader from '../Loader/GlobalLoader';

const MainLayout = () => {
  const theme = useTheme();
  const location = useLocation();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const [isSidebarOpen, setIsSidebarOpen] = useState(isMobile ? false : true);
  const [isLoading, setIsLoading] = useState(false);

  // Sidebar width - Desktop: 65px, Mobile: 240px
  const sidebarWidth = isSidebarOpen ? (isMobile ? '240px' : '65px') : 0;

  useEffect(() => {
    setIsLoading(true);
    const timer = setTimeout(() => setIsLoading(false), 600);
    if (isMobile) setIsSidebarOpen(false);
    return () => clearTimeout(timer);
  }, [location.pathname, isMobile]);

  const handleToggle = () => setIsSidebarOpen(!isSidebarOpen);

  return (
    <Box sx={{ 
      display: 'flex', 
      bgcolor: '#f4f7fa', 
      height: '100vh', 
      width: '100vw', 
      overflow: 'hidden', // पूर्ण स्क्रीनचा स्क्रोल बंद
      position: 'fixed', // स्क्रीनला हलू न देण्यासाठी
      top: 0,
      left: 0
    }}>
      
      <GlobalLoader open={isLoading} />

      {/* १. साईडबार */}
      <Box sx={{
        width: sidebarWidth,
        transition: 'width 0.3s ease',
        height: '100vh',
        position: isMobile ? 'fixed' : 'relative',
        zIndex: 1300,
        bgcolor: '#ffffff',
        borderRight: '1px solid #E2E8F0',
        overflow: 'hidden',
      }}>
        <Sidebar />
      </Box>

      {/* २. राईट साईड कंटेनर */}
      <Box sx={{
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        width: isMobile ? '100%' : `calc(100% - ${sidebarWidth})`,
        overflow: 'hidden', // याला स्क्रोल देऊ नका
      }}>
        
        {/* टॉपबार (65px) */}
        <Topbar toggleSidebar={handleToggle} />

        {/* ३. मधला स्क्रोलिंग भाग (Outlet) */}
        <Box 
          component="main"
          sx={{
            flexGrow: 1,
            width: '100%',
            overflowY: 'auto', // फक्त इथेच स्क्रोल होईल
            bgcolor: '#f4f7fa',
            p: { xs: 1, md: 2 },
            // सर्वात महत्वाचे: उंची फिक्स करणे (100vh - Topbar - Footer)
            height: 'calc(100vh - 65px - 35px)',
            display: 'block', // Flex मुळे कधी कधी उंची प्रॉब्लेम येतो, म्हणून block
          }}
        >
          <Outlet />
        </Box>

        {/* ४. फिक्स्ड फुटर (कधीही लपणार नाही) */}
        <Box 
          component="footer" 
          sx={{ 
            height: '35px', 
            bgcolor: '#ffffff', 
            borderTop: '1px solid #E2E8F0',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexShrink: 0, // फुटरला दबण्यापासून वाचवते
            width: '100%',
            zIndex: 1200,
            boxShadow: '0px -2px 5px rgba(0,0,0,0.03)'
          }}
        >
          <Typography 
            variant="caption" 
            sx={{ 
              fontWeight: 800, 
              textTransform: 'uppercase', 
              letterSpacing: '1px',
              fontSize: '0.65rem',
              color: '#1a237e'
            }}
          >
            <span style={{ color: '#E91E63' }}>COM</span>
            <span style={{ color: '#03A9F4' }}>TRANSE</span> 
            <span style={{ color: '#1E293B', marginLeft: '4px' }}>TECHNOLOGY PVT.LTD.KOLHAPUR</span>
          </Typography>
        </Box>
      </Box>

      {isMobile && isSidebarOpen && (
        <Box 
          onClick={handleToggle} 
          sx={{ 
            position: 'absolute', inset: 0, bgcolor: 'rgba(0,0,0,0.3)', zIndex: 1200 
          }} 
        />
      )}
    </Box>
  );
};

export default MainLayout;